import {favouriteService} from "../../Service/FavouriteService";
import {movieService} from "../../Service/MovieService";

export const getFavourite = () => async (dispatch) => {
    try {
        const res = await favouriteService.favorites();

        if (res && res.data) {
            dispatch({
                type: "GET_FAVOURITE",
                payload: res.data,
            });
            return res.data;
        } else {
            console.log("Không có dữ liệu trả về từ API tạo URL thanh toán");
            throw new Error('Dữ liệu không hợp lệ');
        }
    } catch (error) {
        console.error("Đã xảy ra lỗi:", error);
        throw error; // Truyền lỗi cho phần gọi useEffect
    }
};

export const removeFavourite = (movieId) => async (dispatch) => {
    try {
        const res = await favouriteService.removeFavorites(movieId);
        const msg = res?.message !== undefined ? res.message : res;
        dispatch({ type: "REMOVE_FAVOURITE", payload: msg });
        return msg;
    } catch (error) {
        console.error("Đã xảy ra lỗi:", error);
        throw error;
    }
};

export const pushFavourite = (movieId) => async (dispatch) => {
    try {
        const res = await favouriteService.pushFavorites(movieId);
        const msg = res?.message !== undefined ? res.message : res;
        dispatch({ type: "PUSH_FAVOURITE", payload: msg });
        return msg;
    } catch (error) {
        console.error("Đã xảy ra lỗi:", error);
        throw error;
    }
};

export const check = (movieId) => async (dispatch) => {
    try {
        const res = await favouriteService.checkFavorites(movieId);
        const data = res?.data !== undefined ? res.data : res;
        dispatch({ type: "PUSH_FAVOURITE", payload: data });
        return data;
    } catch (error) {
        console.error("check favourite error:", error);
        return false;
    }
};

export const searchFavorite = (searchParams) => async (dispatch) => {
    try {
        const res = await favouriteService.movieFavoriteSearch(searchParams);
        console.log("searchParams:", searchParams);

        if (res && res.data) {
            dispatch({
                type: "FVR_SEARCH",
                payload: res.data,
            });
            return res.data;
        } else {
            console.log("Không có dữ liệu trả về từ API");
            throw new Error('Dữ liệu không hợp lệ');
        }
    } catch (error) {
        console.error("Đã xảy ra lỗi:", error);
        throw error;
    }
};